import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Session', prop: 'session_id', references: 'admin/sessions', referenceProp: 'long_name' },
  { title: 'Text', prop: 'text' },
  { title: 'Created', prop: 'created_at', format: 'dateWithDay' },
  { title: 'Start', prop: 'start_at', format: 'dateWithTime' },
  { title: 'End', prop: 'end_at', format: 'dateWithTime' },
  { title: 'Link URL', prop: 'link_url' }
]

const filters = [
  { name: 'Filter by session', prop: 'filters.session_id', type: 'autocomplete', references: 'admin/sessions', referenceProp: 'name', displayProp: 'long_name', enabled: true }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const SessionNotifications = (props) => (
  <List
    title='Session Notifications'
    apiPath='admin/session_notifications'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default SessionNotifications
